import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "bbw_cart_v1";
const MAX_QUANTITY = 25;
const FulfillmentContext = createContext(null);

function readCart() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((line) => line && typeof line.product_id === "string" && Number.isInteger(line.quantity) && line.quantity > 0).map((line) => ({
      product_id: line.product_id,
      variant_id: typeof line.variant_id === "string" ? line.variant_id : null,
      quantity: Math.min(line.quantity, MAX_QUANTITY),
      personalization_text: typeof line.personalization_text === "string" ? line.personalization_text.slice(0, 500) : null,
      selected_options: line.selected_options && typeof line.selected_options === "object" ? line.selected_options : {},
      personalization: line.personalization && typeof line.personalization === "object" ? line.personalization : {},
      additional_notes: typeof line.additional_notes === "string" ? line.additional_notes.slice(0, 250) : null,
      line_id: typeof line.line_id === "string" ? line.line_id : crypto.randomUUID(),
    }));
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [lines, setLines] = useState(readCart);
  const [fulfillmentMethod, setFulfillmentMethod] = useState("pickup");

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(lines));
  }, [lines]);

  const addItem = (selection) => {
    setLines((current) => {
      const selectionOptions = selection.selected_options || {};
      const selectionPersonalization = selection.personalization || {};
      const selectionNotes = selection.additional_notes || null;
      const sameSelections = (line) => JSON.stringify(line.selected_options || {}) === JSON.stringify(selectionOptions) && JSON.stringify(line.personalization || {}) === JSON.stringify(selectionPersonalization) && (line.additional_notes || null) === selectionNotes;
      const match = current.find((line) => line.product_id === selection.product_id && line.variant_id === (selection.variant_id || null) && line.personalization_text === (selection.personalization_text || null) && sameSelections(line));
      if (match) return current.map((line) => line.line_id === match.line_id ? { ...line, quantity: Math.min(MAX_QUANTITY, line.quantity + 1) } : line);
      return [...current, { product_id: selection.product_id, variant_id: selection.variant_id || null, quantity: 1, personalization_text: selection.personalization_text || null, selected_options: selectionOptions, personalization: selectionPersonalization, additional_notes: selectionNotes, line_id: crypto.randomUUID() }];
    });
  };

  const updateQuantity = (lineId, quantity) => setLines((current) => current.map((line) => line.line_id === lineId ? { ...line, quantity: Math.max(1, Math.min(MAX_QUANTITY, quantity)) } : line));
  const removeItem = (lineId) => setLines((current) => current.filter((line) => line.line_id !== lineId));
  const clearCart = () => setLines([]);
  const itemCount = useMemo(() => lines.reduce((total, line) => total + line.quantity, 0), [lines]);

  return <FulfillmentContext.Provider value={{ lines, addItem, updateQuantity, removeItem, clearCart, itemCount, fulfillmentMethod, setFulfillmentMethod, maxQuantity: MAX_QUANTITY }}>{children}</FulfillmentContext.Provider>;
}

export const useCart = () => useContext(FulfillmentContext);
